import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/languages/')({
  component: RouteComponent,
})

// TODO: Chưa implement - Trang quản lý ngôn ngữ
function RouteComponent() {
  return <div>Hello "/_authenticated/languages/"!</div>
}
